const updateTotalEvents = (state, payload) => {
  state.totalEvents = payload
}

const updateSelectedEvent = (state, payload) => {
  state.selectedEvent = payload
}

const updateSelectedEventIndex = (state, payload) => {
  state.selectedEventIndex = payload
}

export default {
  updateTotalEvents,
  updateSelectedEvent,
  updateSelectedEventIndex,
}
